import React from 'react'

import {Link, P, H4} from '../UI/index.js'
import t from '../../helpers/Languages.js'

class NotificationContent extends React.PureComponent {
    render() {
        const {notification, showTitle, subtitle} = this.props

        return (
            <div>
                {showTitle && (
                    <H4 style={{marginBottom: subtitle ? 4 : 12}}>{notification.title}</H4>
                )}

                {subtitle}

                {notification.imageSrc &&
                    <div style={{width: '100%', marginBottom: 24}}>
                        <img style={{display: 'block', margin: 'auto', maxWidth: '100%'}} src={notification.imageSrc} />
                    </div>
                }

                <P style={{fontSize: 16}}>
                    <div dangerouslySetInnerHTML={{__html: notification.message}} />
                </P>

                <br />
                {notification.moreInfoUrl && (
                    <Link href={notification.moreInfoUrl}>
                        {t('moreInformation')}
                    </Link>
                )}
            </div>
        )
    }
}

export default NotificationContent
